import type { ReactNode } from "react";

interface AppLayoutProps {
  children: ReactNode;
}

const AuthLayout = ({ children }: AppLayoutProps) => {
  return (
    <div className="min-h-screen bg-muted text-foreground flex flex-col items-center px-4 py-6 space-y-6">

      {/* Main Content */}
      <main className="w-full max-w-4xl">{children}</main>
    </div>
  );
};

export default AuthLayout;
